class StickyAddToCart extends HTMLElement {
    constructor() {
        super()
        // show sticky ATC selection section
        this.add_to_cart_button = this.querySelector(".sticky_add_to_cart_wrapper .button_cart");
        this.active = document.querySelector("sticky-add-to-cart");
        this.add_to_cart_button.addEventListener("click", () => {
            this.active.classList.add("active");
        })

        // sync quantity selector sticky ATC and PDP
        this.quantityInput = this.querySelector(".sticky_add_to_cart_wrapper .quantity__input");
        this.quantityInput.addEventListener("change", this.synchInputs.bind(this));
        this.formQuantityInput = document.querySelector(".product__info-wrapper .quantity__input");
        this.formQuantityInput.addEventListener("change", this.synchInputs.bind(this));

        // sync variant selector sticky ATC and PDP
        this.stickyRadios = this.querySelector(".sticky_add_to_cart_wrapper variant-radios");
        this.stickyRadios?.addEventListener("change", this.synchRadioInputsSticky.bind(this));
        this.radios = document.querySelector(".product__info-wrapper variant-radios");
        this.radios?.addEventListener("change", this.synchRadioInputs.bind(this));

        // display sticky ATC when scrolling down
        this.pdpAddToCartButton = document.querySelector(".product__info-wrapper product-form");
        this.stickyAddToCart = this.querySelector(".sticky_add_to_cart_wrapper");
        window.addEventListener("scroll", this.displayStickyAddToCart.bind(this));

        // close sticky ATC selection section
        this.closeButton = this.querySelector(".sticky_add_to_cart_close");
        this.closeButton.addEventListener("click", this.closeStickyAddToCart.bind(this));
        this.background_filter = this.querySelector(".sticky_add_to_cart_background_filter");
        this.background_filter.addEventListener("click", this.closeStickyAddToCart.bind(this));

        // Click PDP Submitbutton when Sticky Add To Cart Button is clicked
        this.add_to_cart_submit = this.querySelector(".sticky_add_to_cart_wrapper .button_cart_submit");
        this.pdpSubmitButton = document.querySelector(".product__info-wrapper .product-form__buttons > button");
        this.add_to_cart_submit.addEventListener("click", () => {
            this.pdpSubmitButton.click();
            this.active.classList.remove("active");
            this.quantityInput.value = this.quantityInput.min;
        });
        this.pdpSubmitButton.addEventListener("mousedown", () => {
            this.quantityInput.value = this.quantityInput.min;
        })      
    }

    synchInputs(event) {
        if (event.target == this.formQuantityInput) {
            this.quantityInput.value = this.formQuantityInput.value;
        }
        if (event.target == this.quantityInput) {
            this.formQuantityInput.value = this.quantityInput.value
        }
    }

    synchRadioInputsSticky() {
        let radioStickyId = this.querySelector('.sticky_add_to_cart_wrapper input[name="Gewicht-custom"]:checked').id;
        let radioSync = document.querySelector(".product__info-wrapper #" + radioStickyId.replace("-custom", ""));
        radioSync.checked = true;
    }

    synchRadioInputs() {
        let radioId = document.querySelector('.product__info-wrapper input[name="Gewicht"]:checked').id;
        let radioStickySync = this.querySelector(".sticky_add_to_cart_wrapper #" + radioId + "-custom");
        radioStickySync.checked = true;
    }

    displayStickyAddToCart() {
        let variantY = this.pdpAddToCartButton.getBoundingClientRect().top;
        if (variantY <= 350) {
            this.stickyAddToCart.classList.remove("hidden");
        } else {
            this.stickyAddToCart.classList.add("hidden");
        }
    }

    closeStickyAddToCart() {
        this.active.classList.remove("active");
    }
}
customElements.define("sticky-add-to-cart",StickyAddToCart)